import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/cases/')({
  beforeLoad: () => {
    throw redirect({ to: '/cases/active', search: { page: 1 } })
  },
})
